__turbopack_context__.v({
  "root": "RareCarousel-module__gdvwYa__root",
});
